export const certapplyConstants = {
    CERTAPPLY_REQUEST: 'CERTAPPLY_LOAD_REQUEST',
    CERTAPPLY_SUCCESS: 'CERTAPPLY_LOAD_SUCCESS',
    CERTAPPLY_FAILURE: 'CERTAPPLY_LOAD_FAILURE',

    CERTAPPLY_CLOSE: 'CERTAPPLY_CLOSE',
    CERTAPPLY_TOGGLE_TYPE: 'CERTAPPLY_TOGGLE_TYPE',
    CERTAPPLY_GUIDE_TYPE: 'CERTAPPLY_GUIDE_TYPE',

    GET_DOCNUM_REQUEST : 'GET_DOCNUM_REQUEST',
    GET_DOCNUM_SUCCESS : 'GET_DOCNUM_SUCCESS',
    GET_DOCNUM_FAILURE : 'GET_DOCNUM_FAILURE',

    RESET_CALLED: 'RESET_CALLED',
    SHOW_POPUP_ITEMS: 'SHOW_POPUP_ITEMS',
    SELECT_POPUP_ITEMS: 'SELECT_POPUP_ITEMS',

    GET_CONFIRMATION_REQUEST : 'GET_CONFIRMATION_REQUEST',
    GET_CONFIRMATION_SUCCESS : 'GET_CONFIRMATION_SUCCESS',
    GET_CONFIRMATION_FAILURE : 'GET_CONFIRMATION_FAILURE',

    STEP_SAVE: 'CERTAPPLY_STEP_SAVE',
    SET_STEP_DATA: 'CERTAPPLY_SET_STEP_DATA',
    TEMP_SAVE_REQUEST: 'CERTAPPLY_TEMP_SAVE_REQUEST',
    TEMP_SAVE_SUCCESS: 'CERTAPPLY_TEMP_SAVE_SUCCESS',
    TEMP_SAVE_FAILURE: 'CERTAPPLY_TEMP_SAVE_FAILURE',
    TEMP_SAVE_SUCCESS_LIST: 'CERTAPPLY_TEMP_SAVE_SUCCESS_LIST',

    TEMP_DELETE_REQUEST: 'TEMP_DELETE_REQUEST',
    TEMP_DELETE_SUCCESS: 'TEMP_DELETE_SUCCESS',
    TEMP_DELETE_FAILURE: 'TEMP_DELETE_FAILURE',

    SAVE_REQUEST: 'CERTAPPLY_SAVE_REQUEST',
    SAVE_SUCCESS: 'CERTAPPLY_SAVE_SUCCESS',
    SAVE_FAILURE: 'CERTAPPLY_SAVE_FAILURE',

    ISSUE_REQUEST: 'CERTAPPLY_ISSUE_REQUEST',
    ISSUE_SUCCESS: 'CERTAPPLY_ISSUE_SUCCESS',
    ISSUE_FAILURE: 'CERTAPPLY_ISSUE_FAILURE',

    SEND_REQUEST: 'CERTAPPLY_SEND_REQUEST',
    SEND_SUCCESS: 'CERTAPPLY_SEND_SUCCESS',
    SEND_FAILURE: 'CERTAPPLY_SEND_FAILURE',

    ISSUED_ORDER_REQUEST : 'ISSUED_ORDER_REQUEST',
    ISSUED_ORDER_SUCCESS : 'ISSUED_ORDER_SUCCESS',
    ISSUED_ORDER_FAILURE : 'ISSUED_ORDER_FAILURE',

    ORDER_RESULT_REQUEST : 'ORDER_RESULT_REQUEST',
    ORDER_RESULT_SUCCESS : 'ORDER_RESULT_SUCCESS',
    ORDER_RESULT_FAILURE : 'ORDER_RESULT_FAILURE',

    CANCEL_RESULT_REQUEST : 'CANCEL_RESULT_REQUEST',
    CANCEL_RESULT_SUCCESS : 'CANCEL_RESULT_SUCCESS',
    CANCEL_RESULT_FAILURE : 'CANCEL_RESULT_FAILURE',
    
  	CLEAR_REQUEST: 'CLEAR_REQUEST',
  	
    TEMP_PDF_REQUEST: 'TEMP_PDF_REQUEST',
    TEMP_PDF_SUCCESS: 'TEMP_PDF_SUCCESS',
    TEMP_PDF_FAILURE: 'TEMP_PDF_FAILURE',
}
